import styled from '@emotion/styled';

import {Asterisk} from '../Asterisk';

import type {InputInternalProps, InputStyles} from '../types';

const getStyle = ({isSmall, isFilled, isFocused, isMasked}: InputStyles) => {
  if (isFilled) {
    return {
      top: 4,
      height: 16,
      fontSize: 12,
      letterSpacing: '0.08px',
      display: isSmall ? 'none' : undefined,
    };
  }

  if (isFocused && isMasked) {
    return {
      display: 'none',
    };
  }

  return {
    top: 0,
    height: isSmall ? 32 : 48,
    fontSize: 16,
    textIndent: 3,
  };
};

const LabelComponent = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  user-select: none;
  pointer-events: none;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  transition-duration: 0.2s;
  letter-spacing: 0.12px;

  div {
    position: relative;
    max-width: 100%;

    label {
      display: block;
      padding-right: 10px;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
    }

    svg {
      position: absolute;
      top: 0;
      right: 3px;
    }
  }
`;

type LabelProps = Pick<InputInternalProps, 'error' | 'label' | 'required' | 'style'>;

export const Label: React.FC<LabelProps> = ({error, label, required, style}) => {
  if (!label) {
    return null;
  }

  if (typeof label === 'function') {
    return label({...style, error});
  }

  return (
    <LabelComponent data-label style={getStyle(style)}>
      <div>
        <label>{label}</label>
        {required && <Asterisk />}
      </div>
    </LabelComponent>
  );
};
